import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageService } from 'src/app/core/page/page.service';
import { Store } from '@ngrx/store';
import { AppStateInterface } from 'src/app/store/types';
import { selectActiveLanguage } from 'src/app/store/language/selectors';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { TranslateModule } from '@ngx-translate/core';
import { bootstrapEnvelopeFill } from '@ng-icons/bootstrap-icons';

@Component({
    selector: 'app-unsubscribe',
    templateUrl: './unsubscribe.component.html',
    styleUrl: './unsubscribe.component.scss',
    imports: [ReactiveFormsModule, NgIcon, TranslateModule],
    providers: [provideIcons({ bootstrapEnvelopeFill })]
})
export class UnsubscribeComponent {

  lastUrlSegment: string
  languageDirection: string = 'ltr'
  allSettingsAreSelected: boolean = false;
  token!: string
  showEmailForm: boolean = false;
  showCouldNotFindEmailMessage = false
  showSuccesfullyUpdatedSettings = false;
  allEmailsAreSelected: boolean = false;

  emailSettingsFrom = new FormGroup({
    email: new FormControl<null | string>(null),
    activityEmails: new FormControl(true, Validators.required),
    meetingEmails: new FormControl(true, Validators.required),
    newsletterEmails: new FormControl(true, Validators.required),
  });


  constructor(private _pageService: PageService,
              private _store: Store<AppStateInterface>,
              private _router: Router){
    const urlSegments = this._router.url.split('/');
    this.lastUrlSegment = urlSegments[urlSegments.length - 1];
  }

  ngOnInit(){
    const urlSegments = this._router.url.split('/');
    const lastUrlSegment = urlSegments[urlSegments.length - 1];
    if(lastUrlSegment === 'unsubscribe'){
      this.showEmailForm = true
      this.allEmailsAreSelected= true
    } else {
      this.token = lastUrlSegment
      this._pageService.getUserEmailSettings(this.token).subscribe({
        next: result => {
          this.emailSettingsFrom.controls['activityEmails'].setValue(result.activity)
          this.emailSettingsFrom.controls['newsletterEmails'].setValue(result.newsletter)
          const activityEmails = result.newsletter ?? false;
          const newsletterEmails = result.newsletter ?? false;
          this.setAllEmailsAreSelectedValue();
        },
        error: error => {
          if(error && error.error.statusCode === 400) {
            this.showEmailForm = true
            this.showCouldNotFindEmailMessage = true
          }

        }
      })
    }

    this._store.select(selectActiveLanguage).subscribe({
      next: activeLanguage => {
        this.languageDirection = this._pageService.getLanguageDirection(activeLanguage)
      }
    })

    this.emailSettingsFrom.valueChanges.subscribe(() => {
      this.setAllEmailsAreSelectedValue();
    });
  }

  onEmailSettingsFormSubmit(){
    const dto = {
      activity:       this.emailSettingsFrom.controls['activityEmails'].value,
      meetingEmails:  this.emailSettingsFrom.controls['meetingEmails'].value,
      newsletter:     this.emailSettingsFrom.controls['newsletterEmails'].value
    }
    if(this.token){
      this._pageService.saveEmailSettingsViaToken(this.token, dto).subscribe({
        next: result => {
          this.showSuccesfullyUpdatedSettings = true;
        },
        error: error => {}
      })
    } else {
      const email = this.emailSettingsFrom.controls['email'].value
      if(email)
      this._pageService.saveEmailSettingsViaEmail(email, dto).subscribe({
        next: result => {
          this.showSuccesfullyUpdatedSettings = true;
        },
        error: error => {}
      })
    }
  }

  selectOrDeselectAll(){
    if(!this.emailSettingsFrom.get('activityEmails')?.value ||
       !this.emailSettingsFrom.get('meetingEmails')?.value ||
       !this.emailSettingsFrom.get('newsletterEmails')?.value) {
        this.emailSettingsFrom.controls['activityEmails'].setValue(true)
        this.emailSettingsFrom.controls['meetingEmails'].setValue(true)
        this.emailSettingsFrom.controls['newsletterEmails'].setValue(true)
    } else {
      this.emailSettingsFrom.controls['activityEmails'].setValue(false)
      this.emailSettingsFrom.controls['meetingEmails'].setValue(false)
      this.emailSettingsFrom.controls['newsletterEmails'].setValue(false)
    }
  }


  private setAllEmailsAreSelectedValue(){
    if(this.emailSettingsFrom.get('activityEmails')?.value &&
       this.emailSettingsFrom.get('meetingEmails')?.value &&
       this.emailSettingsFrom.get('newsletterEmails')?.value) {
        this.allEmailsAreSelected = true
       } else {
        this.allEmailsAreSelected = false
       }
  }

}
